'use strict';

var loadVideo = {
	$play: $('.js-video-play'),
	$close: $('.js-video-close')
};

var getCookie = function getCookie(name) {
	var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
	if (match) return match[2];
};

var $video_on = false; // = YT off
// console.log('cookie_settings: ')

if (typeof getCookie('cookie_settings') == 'undefined') {
	$video_on = true; // = YT on if cookietool is turned off
}
//if cookie_settings is set and not = default
if (typeof getCookie('cookie_settings') != 'undefined' && getCookie('cookie_settings').indexOf('tracking') >= 1) {
	$video_on = true; // = YT on
}

function open($this, $btn) {
	if (!$this.hasClass('is-active')) {
		$this.addClass('is-active');
		var videoId = $this.find('.js-video').data('target'),
		    type = $this.find('.js-video').data('type'),
		    w = $this.find('.js-video').outerWidth(true),
		    h = $this.find('.js-video').outerHeight(true);

		var $embed = type == 'vimeo' ? '<iframe type="text/html" width="' + w + '" height="' + h + '" src="//player.vimeo.com/video/' + videoId + '?autoplay=1" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" wmode="transparent">' : '<iframe id="ytplayer" type="text/html" width="' + w + '" height="' + h + '" src="//www.youtube.com/embed/' + videoId + '?enablejsapi=1&autoplay=1&rel=0&showinfo=0&color=white&wmode=transparent" frameborder="0" wmode="transparent" allowfullscreen>';

		// Vimeo and youtube are both in marketing cookies
		if ($video_on == false) {
			// $embed = '<div class="js-cookie-btn eagerly-tools-cookie-blocked" data-embed="youtube"><span>'+ cookieData.yt.videoPlayerWarning +'</span><div class="warning-background"></div>';
			$embed = '<div class="js-cookie-btn eagerly-tools-cookie-blocked"><span>Je cookie instellingen blokkeren deze video.<br />Pas <a href="#" class="">je instellingen</a> aan om de video te bekijken.</span><div class="warning-background"></div>';
		}

		$this.find('.embed').html($embed);
		$this.find('.js-cookie-btn').click(function (e) {
			e.preventDefault();
			$('#eagerly-tools-cookie-btn').trigger('click');
		});

		setTimeout(function () {
			$this.find('.js-video').show();
			setTimeout(function () {
				$this.find('.js-video').addClass('show');
				$this.find('.btn-play').fadeOut();
			}, 10);
		}, 600);
	}
}

function close($this, $close) {
	if ($this.hasClass('is-active')) {
		$this.find('.js-video').removeClass('show');
		$this.find('.btn-play').fadeIn();
		setTimeout(function () {
			$this.removeClass('is-active');
			$this.find('.embed').find('iframe').remove();
		}, 500);
	}
}

loadVideo.init = function () {

	loadVideo.$play.click(function (e) {
		e.preventDefault();
		var $this = $(this).parents('.js-video-container'),
		    $btn = $(this);
		open($this, $btn);
	});

	loadVideo.$close.click(function (e) {
		e.preventDefault();
		var $this = $(this).parents('.js-video-container'),
		    $close = $(this);
		close($this, $close);
	});
};